import { Typography, styled } from '@mui/material'

export const BannerLabel = styled(Typography)`
  white-space: nowrap;
`
